import {Divider} from '@/components/ui/divider/Divider'
import {MedicalReportSectionTitle} from '../medical-report-section-title/MedicalReportSectionTitle'
import {FormSection} from '@/components/commons/form-section/FormSection'
import {useTranslation} from '@/translations/i18n'
import {ReferenceContactFields} from '../reference-contact-fields/ReferenceContactFields'
import {FamilySituationFields} from '../family-situation-fields/FamilySituationFields'
import {FamilyAtmosphereFields} from '../family-atmosphere-fields/FamilyAtmosphereFields'

export const FamilyNetworkSections = () => {
    const {t} = useTranslation()

    return (
        <>
            <MedicalReportSectionTitle>{t('medical_records:family_network')}</MedicalReportSectionTitle>
            <ReferenceContactSection />
            <Divider direction="horizontal" />
            <FamilySituationSection />
            <Divider direction="horizontal" />
            <FamilyAtmosphereSection />
        </>
    )
}

const ReferenceContactSection = () => {
    const {t} = useTranslation()

    return (
        <FormSection title={t('medical_records:reference_contact_section_title')}>
            <ReferenceContactFields />
        </FormSection>
    )
}

const FamilySituationSection = () => {
    const {t} = useTranslation()

    return (
        <FormSection title={t('medical_records:family_situation_section_title')}>
            <FamilySituationFields />
        </FormSection>
    )
}

const FamilyAtmosphereSection = () => {
    const {t} = useTranslation()

    return (
        <FormSection title={t('medical_records:family_atmosphere_section_title')}>
            <FamilyAtmosphereFields />
        </FormSection>
    )
}
